// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"9bd3d64e","63":"d7ede0fb","197":"875fc97e","218":"a611efd5","314":"df0838c7","615":"f66d19ba","660":"b95cfa7b","661":"6f55ad5d","708":"d7c2d497","895":"7838c4d1","938":"03ab0ffe"}[chunkId] + ".chunk.js";
};